// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23605e5c%27 d=%27M2 4l4 4 4-4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #0078d4;
  --primary-hover: #106ebe;
  --secondary: #605e5c;
  --bg: #ffffff;
  --surface: #f3f2f1;
  --text: #323130;
  --text-muted: #8a8886;
  --border: #edebe9;
  --error-bg: #fde7e9;
  --error-text: #a80000;
  --success: #107c10;
  --radius: 6px;
}

:root.dark-theme {
  --primary: #4ca6e8;
  --primary-hover: #6ab8f0;
  --secondary: #b3b0ad;
  --bg: #1e1e1e;
  --surface: #2d2d2d;
  --text: #e0e0e0;
  --text-muted: #a0a0a0;
  --border: #3c3c3c;
  --error-bg: #442222;
  --error-text: #f48771;
  --success: #4ec94e;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family:
    "Segoe UI",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  font-size: 14px;
  color: var(--text);
  background: var(--bg);
  line-height: 1.5;
}

#app {
  padding: 16px;
  max-width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

header h1 {
  font-size: 18px;
  font-weight: 600;
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.header-logo {
  width: 24px;
  height: 24px;
}

.header-action {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  padding: 4px;
}

#back-btn {
  left: 0;
  right: auto;
}

/* Cards (shared) */
.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  margin: 10px 0;
}

/* Advanced collapsible section (wraps the Agent card) */
.advanced {
  margin-top: 12px;
}

.advanced > .advanced-summary {
  list-style: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 4px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-muted);
  user-select: none;
}

.advanced > .advanced-summary::-webkit-details-marker {
  display: none;
}

.advanced-chevron {
  display: inline-block;
  transition: transform 0.15s ease;
  color: var(--text-muted);
}

.advanced[open] .advanced-chevron {
  transform: rotate(90deg);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid var(--border);
  background: var(--bg);
}

.card-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-header h3,
.card-header h2 {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  margin: 0;
}

.card-icon {
  font-size: 18px;
  line-height: 1;
}

.card-body {
  padding: 16px;
}

.card-description {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 10px;
  line-height: 1.4;
}

.card-description a {
  color: var(--primary);
  text-decoration: none;
}

.card-description a:hover {
  text-decoration: underline;
}

.settings-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 13px;
  font-family: inherit;
  color: var(--text);
  background: var(--bg);
  transition: border-color 0.15s;
}

.settings-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 1px var(--primary);
}

/* Agent dropdown */
select.settings-input {
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 28px;
  cursor: pointer;
}

select.settings-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Test connection button */
.btn-test-connection {
  width: 100%;
  margin-top: 10px;
  background: var(--primary);
  color: white;
  font-size: 12px;
  padding: 8px 18px;
  font-weight: 600;
}

.btn-test-connection:hover:not(:disabled) {
  background: var(--primary-hover);
}

/* Connection / agent status messages */
.connection-status {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: var(--radius);
  font-size: 12px;
  line-height: 1.4;
}

.connection-status-success {
  background: color-mix(in srgb, var(--success) 15%, transparent);
  color: var(--success);
}

.connection-status-error {
  background: var(--error-bg);
  color: var(--error-text);
}

.connection-status-warning {
  background: color-mix(in srgb, orange 15%, transparent);
  color: #996a13;
}

:root.dark-theme .connection-status-warning {
  color: #e8a735;
}

#main-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

#main-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

#settings-view {
  flex: 1;
}

/* Version footer */
.app-footer {
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid var(--border);
  text-align: right;
}

.version-text {
  font-size: 10px;
  color: var(--text-muted);
  font-style: italic;
  font-weight: bold;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: var(--radius);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.15s,
    opacity 0.15s;
  font-family: inherit;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-reply {
  width: 100%;
  background: #107c10;
  color: white;
  margin: 0 0 12px 0;
}

.btn-reply:hover:not(:disabled) {
  background: #0b5e0b;
}

/* Tone rewrite */
#tone-section {
  margin-bottom: 12px;
}

.tone-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.tone-chip {
  flex: 1 1 calc(50% - 8px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
  color: var(--text);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.15s,
    border-color 0.15s,
    color 0.15s;
}

.tone-chip-icon {
  font-size: 15px;
  line-height: 1;
}

.tone-chip:hover:not(:disabled) {
  border-color: var(--primary);
}

.tone-chip.active {
  background: var(--primary);
  border-color: var(--primary);
  color: #ffffff;
}

.tone-chip:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tone-actions {
  margin-bottom: 12px;
}

.tone-applied-status {
  font-size: 13px;
  font-weight: 600;
  color: var(--success);
  text-align: center;
}

#custom-instructions-section {
  margin-bottom: 12px;
}

#custom-instructions-section label {
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 13px;
  color: var(--text);
}

.custom-prompt-textarea {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-family: inherit;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text);
  background: var(--bg);
  resize: vertical;
  margin-bottom: 10px;
}

.custom-prompt-textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 1px var(--primary);
}

.btn-secondary {
  background: var(--primary);
  color: white;
  font-size: 12px;
  padding: 8px 18px;
  font-weight: 600;
}

.btn-secondary:hover {
  background: var(--primary-hover);
}

.btn-icon {
  background: transparent;
  padding: 4px 8px;
  font-size: 16px;
  border-radius: 4px;
  color: var(--text);
}

.btn-icon:hover {
  background: var(--surface);
}

/* Email preview */
#email-preview {
  background: var(--surface);
  border-radius: var(--radius);
  padding: 12px;
  font-size: 13px;
  max-height: 150px;
  overflow-y: auto;
}

#email-preview .email-meta {
  margin-bottom: 8px;
  color: var(--secondary);
  font-size: 12px;
}

#email-preview .email-meta strong {
  color: var(--text);
}

/* Response */
#response-box {
  margin-top: 16px;
  flex: 0 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

#response-content {
  font-size: 13px;
  word-break: break-word;
  flex: 0 1 auto;
  overflow-y: auto;
  min-height: 0;
}

#response-content h1,
#response-content h2,
#response-content h3 {
  margin: 12px 0 6px;
  font-weight: 600;
  color: var(--text);
}

#response-content h1 {
  font-size: 16px;
}
#response-content h2 {
  font-size: 14px;
}
#response-content h3 {
  font-size: 13px;
}

#response-content p {
  margin: 6px 0;
}

#response-content ul,
#response-content ol {
  margin: 6px 0;
  padding-left: 20px;
}

#response-content li {
  margin: 3px 0;
}

#response-content code {
  background: var(--surface);
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 12px;
}

#response-content pre {
  background: var(--surface);
  padding: 8px 10px;
  border-radius: var(--radius);
  overflow-x: auto;
  margin: 8px 0;
}

#response-content pre code {
  background: none;
  padding: 0;
}

#response-content strong {
  font-weight: 600;
}

#response-content blockquote {
  border-left: 3px solid var(--primary);
  margin: 8px 0;
  padding: 4px 10px;
  color: var(--text-muted);
}

#response-content hr {
  border: none;
  border-top: 1px solid var(--border);
  margin: 10px 0;
}

#response-content a {
  color: var(--primary);
  text-decoration: none;
}

#response-content a:hover {
  text-decoration: underline;
}

/* Error */
#error-box {
  margin-top: 12px;
  padding: 10px 12px;
  background: var(--error-bg);
  color: var(--error-text);
  border-radius: var(--radius);
  font-size: 13px;
}

/* Spinner */
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Loading card */
#loading-box {
  margin-top: 16px;
}

#loading-box .card-header h2 {
  animation: pulse-text 1.5s ease-in-out infinite;
}

@keyframes pulse-text {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.loading-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.shimmer-line {
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    var(--border) 25%,
    var(--surface) 50%,
    var(--border) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
}

.shimmer-long {
  width: 100%;
}
.shimmer-medium {
  width: 75%;
}
.shimmer-short {
  width: 50%;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.hidden {
  display: none !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--secondary);
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/taskpane.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;;;;cAIY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,uDAAuD;EACvD,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;iBAEe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;eAGa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[":root {\n  --primary: #0078d4;\n  --primary-hover: #106ebe;\n  --secondary: #605e5c;\n  --bg: #ffffff;\n  --surface: #f3f2f1;\n  --text: #323130;\n  --text-muted: #8a8886;\n  --border: #edebe9;\n  --error-bg: #fde7e9;\n  --error-text: #a80000;\n  --success: #107c10;\n  --radius: 6px;\n}\n\n:root.dark-theme {\n  --primary: #4ca6e8;\n  --primary-hover: #6ab8f0;\n  --secondary: #b3b0ad;\n  --bg: #1e1e1e;\n  --surface: #2d2d2d;\n  --text: #e0e0e0;\n  --text-muted: #a0a0a0;\n  --border: #3c3c3c;\n  --error-bg: #442222;\n  --error-text: #f48771;\n  --success: #4ec94e;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family:\n    \"Segoe UI\",\n    -apple-system,\n    BlinkMacSystemFont,\n    sans-serif;\n  font-size: 14px;\n  color: var(--text);\n  background: var(--bg);\n  line-height: 1.5;\n}\n\n#app {\n  padding: 16px;\n  max-width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nheader {\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\nheader h1 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.header-logo {\n  width: 24px;\n  height: 24px;\n}\n\n.header-action {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 18px;\n  padding: 4px;\n}\n\n#back-btn {\n  left: 0;\n  right: auto;\n}\n\n/* Cards (shared) */\n.card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  overflow: hidden;\n  margin: 10px 0;\n}\n\n/* Advanced collapsible section (wraps the Agent card) */\n.advanced {\n  margin-top: 12px;\n}\n\n.advanced > .advanced-summary {\n  list-style: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 4px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-muted);\n  user-select: none;\n}\n\n.advanced > .advanced-summary::-webkit-details-marker {\n  display: none;\n}\n\n.advanced-chevron {\n  display: inline-block;\n  transition: transform 0.15s ease;\n  color: var(--text-muted);\n}\n\n.advanced[open] .advanced-chevron {\n  transform: rotate(90deg);\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--border);\n  background: var(--bg);\n}\n\n.card-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.card-header h3,\n.card-header h2 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text);\n  margin: 0;\n}\n\n.card-icon {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.card-body {\n  padding: 16px;\n}\n\n.card-description {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-bottom: 10px;\n  line-height: 1.4;\n}\n\n.card-description a {\n  color: var(--primary);\n  text-decoration: none;\n}\n\n.card-description a:hover {\n  text-decoration: underline;\n}\n\n.settings-input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 13px;\n  font-family: inherit;\n  color: var(--text);\n  background: var(--bg);\n  transition: border-color 0.15s;\n}\n\n.settings-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 1px var(--primary);\n}\n\n/* Agent dropdown */\nselect.settings-input {\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23605e5c' d='M2 4l4 4 4-4'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  padding-right: 28px;\n  cursor: pointer;\n}\n\nselect.settings-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Test connection button */\n.btn-test-connection {\n  width: 100%;\n  margin-top: 10px;\n  background: var(--primary);\n  color: white;\n  font-size: 12px;\n  padding: 8px 18px;\n  font-weight: 600;\n}\n\n.btn-test-connection:hover:not(:disabled) {\n  background: var(--primary-hover);\n}\n\n/* Connection / agent status messages */\n.connection-status {\n  margin-top: 10px;\n  padding: 8px 12px;\n  border-radius: var(--radius);\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.connection-status-success {\n  background: color-mix(in srgb, var(--success) 15%, transparent);\n  color: var(--success);\n}\n\n.connection-status-error {\n  background: var(--error-bg);\n  color: var(--error-text);\n}\n\n.connection-status-warning {\n  background: color-mix(in srgb, orange 15%, transparent);\n  color: #996a13;\n}\n\n:root.dark-theme .connection-status-warning {\n  color: #e8a735;\n}\n\n#main-view {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n#main-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n#settings-view {\n  flex: 1;\n}\n\n/* Version footer */\n.app-footer {\n  margin-top: auto;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n  text-align: right;\n}\n\n.version-text {\n  font-size: 10px;\n  color: var(--text-muted);\n  font-style: italic;\n  font-weight: bold;\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    opacity 0.15s;\n  font-family: inherit;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-reply {\n  width: 100%;\n  background: #107c10;\n  color: white;\n  margin: 0 0 12px 0;\n}\n\n.btn-reply:hover:not(:disabled) {\n  background: #0b5e0b;\n}\n\n/* Tone rewrite */\n#tone-section {\n  margin-bottom: 12px;\n}\n\n.tone-presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.tone-chip {\n  flex: 1 1 calc(50% - 8px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--surface);\n  color: var(--text);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    border-color 0.15s,\n    color 0.15s;\n}\n\n.tone-chip-icon {\n  font-size: 15px;\n  line-height: 1;\n}\n\n.tone-chip:hover:not(:disabled) {\n  border-color: var(--primary);\n}\n\n.tone-chip.active {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: #ffffff;\n}\n\n.tone-chip:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.tone-actions {\n  margin-bottom: 12px;\n}\n\n.tone-applied-status {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--success);\n  text-align: center;\n}\n\n#custom-instructions-section {\n  margin-bottom: 12px;\n}\n\n#custom-instructions-section label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 6px;\n  font-size: 13px;\n  color: var(--text);\n}\n\n.custom-prompt-textarea {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--text);\n  background: var(--bg);\n  resize: vertical;\n  margin-bottom: 10px;\n}\n\n.custom-prompt-textarea:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 1px var(--primary);\n}\n\n.btn-secondary {\n  background: var(--primary);\n  color: white;\n  font-size: 12px;\n  padding: 8px 18px;\n  font-weight: 600;\n}\n\n.btn-secondary:hover {\n  background: var(--primary-hover);\n}\n\n.btn-icon {\n  background: transparent;\n  padding: 4px 8px;\n  font-size: 16px;\n  border-radius: 4px;\n  color: var(--text);\n}\n\n.btn-icon:hover {\n  background: var(--surface);\n}\n\n/* Email preview */\n#email-preview {\n  background: var(--surface);\n  border-radius: var(--radius);\n  padding: 12px;\n  font-size: 13px;\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n#email-preview .email-meta {\n  margin-bottom: 8px;\n  color: var(--secondary);\n  font-size: 12px;\n}\n\n#email-preview .email-meta strong {\n  color: var(--text);\n}\n\n/* Response */\n#response-box {\n  margin-top: 16px;\n  flex: 0 1 auto;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n#response-content {\n  font-size: 13px;\n  word-break: break-word;\n  flex: 0 1 auto;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n#response-content h1,\n#response-content h2,\n#response-content h3 {\n  margin: 12px 0 6px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n#response-content h1 {\n  font-size: 16px;\n}\n#response-content h2 {\n  font-size: 14px;\n}\n#response-content h3 {\n  font-size: 13px;\n}\n\n#response-content p {\n  margin: 6px 0;\n}\n\n#response-content ul,\n#response-content ol {\n  margin: 6px 0;\n  padding-left: 20px;\n}\n\n#response-content li {\n  margin: 3px 0;\n}\n\n#response-content code {\n  background: var(--surface);\n  padding: 1px 4px;\n  border-radius: 3px;\n  font-size: 12px;\n}\n\n#response-content pre {\n  background: var(--surface);\n  padding: 8px 10px;\n  border-radius: var(--radius);\n  overflow-x: auto;\n  margin: 8px 0;\n}\n\n#response-content pre code {\n  background: none;\n  padding: 0;\n}\n\n#response-content strong {\n  font-weight: 600;\n}\n\n#response-content blockquote {\n  border-left: 3px solid var(--primary);\n  margin: 8px 0;\n  padding: 4px 10px;\n  color: var(--text-muted);\n}\n\n#response-content hr {\n  border: none;\n  border-top: 1px solid var(--border);\n  margin: 10px 0;\n}\n\n#response-content a {\n  color: var(--primary);\n  text-decoration: none;\n}\n\n#response-content a:hover {\n  text-decoration: underline;\n}\n\n/* Error */\n#error-box {\n  margin-top: 12px;\n  padding: 10px 12px;\n  background: var(--error-bg);\n  color: var(--error-text);\n  border-radius: var(--radius);\n  font-size: 13px;\n}\n\n/* Spinner */\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Loading card */\n#loading-box {\n  margin-top: 16px;\n}\n\n#loading-box .card-header h2 {\n  animation: pulse-text 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-text {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.loading-body {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.shimmer-line {\n  height: 12px;\n  border-radius: 4px;\n  background: linear-gradient(\n    90deg,\n    var(--border) 25%,\n    var(--surface) 50%,\n    var(--border) 75%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s ease-in-out infinite;\n}\n\n.shimmer-long {\n  width: 100%;\n}\n.shimmer-medium {\n  width: 75%;\n}\n.shimmer-short {\n  width: 50%;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.hidden {\n  display: none !important;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--secondary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
